import React from "react";
import Grid from "@mui/material/Grid";
import Dashboards from "../panels/dashboards/Dashboards";

export default () => (
  <Grid>
      <Dashboards/>
  </Grid>
);
